// Liste des pays (Afrique en premier, puis diaspora fréquente)
export const COUNTRIES = [
    "Cameroun", "Côte d'Ivoire", "Sénégal", "RD Congo", "Congo-Brazzaville", "Gabon",
    "Bénin", "Togo", "Burkina Faso", "Mali", "Niger", "Guinée", "Tchad",
    "République Centrafricaine", "Guinée Équatoriale", "Nigéria", "Ghana", "Kenya",
    "Afrique du Sud", "Rwanda", "Burundi", "Éthiopie", "Tanzanie", "Ouganda",
    "Angola", "Mozambique", "Zambie", "Zimbabwe", "Madagascar", "Maurice",
    "Maroc", "Algérie", "Tunisie", "Égypte", "Mauritanie", "Djibouti", "Comores",
    "Cap-Vert", "Gambie", "Guinée-Bissau", "Liberia", "Sierra Leone", "Somalie",
    "Soudan", "Sud-Soudan", "Lesotho", "Eswatini", "Botswana", "Namibie", "Malawi",
    "Érythrée", "Libye", "Seychelles", "São Tomé-et-Príncipe",
    "France", "Belgique", "Suisse", "Canada", "États-Unis", "Royaume-Uni",
    "Allemagne", "Italie", "Espagne", "Pays-Bas", "Portugal", "Brésil",
    "Haïti", "Guadeloupe", "Martinique", "Guyane", "La Réunion", "Autre",
];
